import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e083cc44"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "bottom-btn-box"
};
const _hoisted_2 = {
  key: 0,
  class: "bottom-btn-start"
};
const _hoisted_3 = {
  key: 1,
  class: "bottom-btn-start bottom-btn-start-no-time"
};
const _hoisted_4 = {
  class: "btn-info"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/reword.png"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看回报", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = {
  key: 1,
  class: "btn-info-left btn-info-left-word"
};
const _hoisted_9 = /*#__PURE__*/_createTextVNode("众筹已结束");
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_11 = /*#__PURE__*/_createTextVNode("商城有售");
const _hoisted_12 = [_hoisted_9, _hoisted_10, _hoisted_11];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/bullish_flase@2x.png"
}, null, -1));
const _hoisted_14 = {
  key: 1,
  class: "btn-info-right gray"
};
const _hoisted_15 = {
  key: 2,
  class: "lottie-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompLottieAnimation = _resolveComponent("CompLottieAnimation");
  const _component_CompReward = _resolveComponent("CompReward");
  return $props.product_info && typeof $props.product_info.status_code !== 'undefined' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$props.product_info.status_code == 1 && $props.product_info.start_time ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.product_info.start_time) + "开始", 1)) : _createCommentVNode("", true), $props.product_info.status_code == 13 ? (_openBlock(), _createElementBlock("div", _hoisted_3, "待发起人设定众筹上线时间")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [$props.product_info.status_code == 1 || $props.product_info.status_code == 13 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn-info-left btn-info-left-reward",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onReward && $options.onReward(...args))
  }, _hoisted_7)) : _createCommentVNode("", true), $props.product_info.advert_info && $props.product_info.advert_info.advert_url > 0 && $props.product_info.status_code == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_12)) : _createCommentVNode("", true), $props.product_info.status_code == 0 && !$props.product_info.if_favor ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "btn-info-left btn-info-left-favor",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onFavor && $options.onFavor(...args))
  }, [_hoisted_13, _createElementVNode("div", null, _toDisplayString($options.formatFavorCount($props.product_info.favor_count)) + "人看好", 1)])) : _createCommentVNode("", true), $props.product_info.status_code == 4 || $props.product_info.pro_class == 102 ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: _normalizeClass(['btn-info-right', {
      'gray': $props.product_info.if_favor
    }]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onFavor && $options.onFavor(...args))
  }, _toDisplayString($props.product_info.if_favor ? '已看好' : '看好创意'), 3)) : $props.product_info.status_code == 13 ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: _normalizeClass(['btn-info-right', {
      'gray': $props.product_info.if_favor
    }]),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.onFavor && $options.onFavor(...args))
  }, _toDisplayString($props.product_info.if_favor ? '已看好' : '看好项目'), 3)) : $props.product_info.status_code == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: _normalizeClass(['btn-info-right', {
      'gray': $props.product_info.if_favor
    }]),
    onClick: _cache[4] || (_cache[4] = (...args) => $options.onFavor && $options.onFavor(...args))
  }, _toDisplayString($props.product_info.if_favor ? '已看好' : '看好项目并预约'), 3)) : $props.product_info.status_code == 0 || $props.product_info.is_preview ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "btn-info-right",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.onReward && $options.onReward(...args))
  }, "立即购买支持")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 7
  }, [$props.product_info.advert_info && $props.product_info.advert_info.advert_url > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn-info-right",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.goProduct && $options.goProduct(...args))
  }, "立即购买")) : (_openBlock(), _createElementBlock("div", _hoisted_14, "众筹已结束，客官下次早点来哦"))], 64))]), $data.showLottie ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_CompLottieAnimation, {
    jsonUrl: "https://p6.moimg.net/mdwxapp/lottie_json/project_info_heart_min.json",
    onOnAnimationComplete: $options.onAnimationComplete
  }, null, 8, ["onOnAnimationComplete"])])) : _createCommentVNode("", true), _createVNode(_component_CompReward, {
    show: $data.show,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $data.show = $event),
    pro_user_id: $props.product_info.user_id,
    pro_id: $props.product_info.id,
    preview_list: $props.product_info.reward_list,
    status_code: $props.product_info.status_code,
    reward_id: $data.reward_id
  }, null, 8, ["show", "pro_user_id", "pro_id", "preview_list", "status_code", "reward_id"])])) : _createCommentVNode("", true);
}